import { getCredentials } from '../../session'
// or import as `serverLoadCredentials` if you prefer name clarity

export function getServerCredentials() {
  return getCredentials() // uses next/headers
}

export function isLoggedIn() {
  return Boolean(getServerCredentials())
}
